module.exports = __webpack_public_path__ + "img/bg26.c112bc65.jpeg";